export const checkIfUserHasRole = (roles: string[], role: string): boolean => {
  if (roles === undefined) return false;
  if (roles?.includes('ROLE_ADMIN')) return true;
  return roles?.includes(role);
};
